import React from "react";

import { useModalContext } from "@shared/context/ModalContext";
import { trackEvent } from "@shared/lib/posthog";

import RunPlatoReviewAllModal from "@ats/src/views/jobApplications/RunPlatoReviewAllModal";
import RunPlatoNoCandidatesModal from "@ats/src/views/jobApplications/RunPlatoNoCandidatesModal";
import RunPlatoAddDescriptionModal from "@ats/src/views/jobApplications/RunPlatoAddDescriptionModal";

export type RunPlatoCtaCardProps = {
  jobId: number;
  jobApplicationsCount: number;
  jobApplicationsSummaryCount: number;
  autoGenerateEnabled: boolean;
  jobDescription?: string;
};

export function useRunPlatoCtaModals(props: RunPlatoCtaCardProps) {
  const { jobId, jobApplicationsCount, jobApplicationsSummaryCount, autoGenerateEnabled, jobDescription } = props;
  const { openModal, removeModal } = useModalContext();

  const handleNoDescription = (event?: React.SyntheticEvent) => {
    event?.preventDefault();
    trackEvent("run_plato_no_description_shown", { job_id: jobId });
    openModal(<RunPlatoAddDescriptionModal jobId={jobId} onCancel={() => removeModal()} />);
  };

  const handleNoCandidates = (event?: React.SyntheticEvent) => {
    event?.preventDefault();
    trackEvent("run_plato_no_candidates_shown", { job_id: jobId, auto_generate_enabled: autoGenerateEnabled });
    openModal(
      <RunPlatoNoCandidatesModal
        jobId={jobId}
        autoGenerateEnabled={autoGenerateEnabled}
        onCancel={() => removeModal()}
      />,
    );
  };

  const handleReviewAll = (event?: React.SyntheticEvent) => {
    event?.preventDefault();
    trackEvent("run_plato_review_all_clicked", { job_id: jobId, candidates_count: jobApplicationsCount });
    openModal(
      <RunPlatoReviewAllModal
        jobId={jobId}
        candidatesCount={jobApplicationsCount}
        summaryCount={jobApplicationsSummaryCount}
        onCancel={() => removeModal()}
      />,
    );
  };

  const handleOnClickRunPlato = (event: React.SyntheticEvent) => {
    event.preventDefault();
    if (!jobDescription) return handleNoDescription(event);
    if (jobApplicationsCount === 0) return handleNoCandidates(event);
    return handleReviewAll(event);
  };

  return { handleOnClickRunPlato, handleNoDescription, handleNoCandidates, handleReviewAll };
}
